export class SortModel {
    static ascIcon: string = '#sort_up';
    static descIcon: string = '#sort_down';
    static disabledIcon: string = "#sort";
    constructor(public fieldId: number, public selectedOrder: string) { }
}

export class SortResult {
    constructor(public existingSortModel: SortModel, public selectedSortModel: SortModel, public sortDiresctionAsc: boolean) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/sort.model.ts